define('areas/navigationmanager/services/iconlist',["require", "exports"], function (require, exports) {
    "use strict";
    var iconlist = (function () {
        function iconlist() {
        }
        iconlist.getFullIconList = function () {
            if (iconlist._icons == null)
                iconlist._icons = iconlist.all();
            return iconlist._icons;
        };
        iconlist.all = function () {
            var icons = [];
            icons.push({ id: "glass", name: "Glass" });
            icons.push({ id: "music", name: "Music" });
            icons.push({ id: "search", name: "Search" });
            icons.push({ id: "envelope-o", name: "Envelope Outlined" });
            icons.push({ id: "heart", name: "Heart" });
            icons.push({ id: "star", name: "Star" });
            icons.push({ id: "star-o", name: "Star Outlined" });
            icons.push({ id: "user", name: "User" });
            icons.push({ id: "film", name: "Film" });
            icons.push({ id: "th-large", name: "th-large" });
            icons.push({ id: "th", name: "th" });
            icons.push({ id: "th-list", name: "th-list" });
            icons.push({ id: "check", name: "Check" });
            icons.push({ id: "times", name: "Times" });
            icons.push({ id: "search-plus", name: "Search Plus" });
            icons.push({ id: "search-minus", name: "Search Minus" });
            icons.push({ id: "power-off", name: "Power Off" });
            icons.push({ id: "signal", name: "signal" });
            icons.push({ id: "cog", name: "cog" });
            icons.push({ id: "trash-o", name: "Trash Outlined" });
            icons.push({ id: "home", name: "home" });
            icons.push({ id: "file-o", name: "File Outlined" });
            icons.push({ id: "clock-o", name: "Clock Outlined" });
            icons.push({ id: "road", name: "road" });
            icons.push({ id: "download", name: "Download" });
            icons.push({ id: "arrow-circle-o-down", name: "Arrow Circle Outlined Down" });
            icons.push({ id: "arrow-circle-o-up", name: "Arrow Circle Outlined Up" });
            icons.push({ id: "inbox", name: "inbox" });
            icons.push({ id: "play-circle-o", name: "Play Circle Outlined" });
            icons.push({ id: "repeat", name: "Repeat" });
            icons.push({ id: "refresh", name: "refresh" });
            icons.push({ id: "list-alt", name: "list-alt" });
            icons.push({ id: "lock", name: "lock" });
            icons.push({ id: "flag", name: "flag" });
            icons.push({ id: "headphones", name: "headphones" });
            icons.push({ id: "volume-off", name: "volume-off" });
            icons.push({ id: "volume-down", name: "volume-down" });
            icons.push({ id: "volume-up", name: "volume-up" });
            icons.push({ id: "qrcode", name: "qrcode" });
            icons.push({ id: "barcode", name: "barcode" });
            icons.push({ id: "tag", name: "tag" });
            icons.push({ id: "tags", name: "tags" });
            icons.push({ id: "book", name: "book" });
            icons.push({ id: "bookmark", name: "bookmark" });
            icons.push({ id: "print", name: "print" });
            icons.push({ id: "camera", name: "camera" });
            icons.push({ id: "font", name: "font" });
            icons.push({ id: "bold", name: "bold" });
            icons.push({ id: "italic", name: "italic" });
            icons.push({ id: "text-height", name: "text-height" });
            icons.push({ id: "text-width", name: "text-width" });
            icons.push({ id: "align-left", name: "align-left" });
            icons.push({ id: "align-center", name: "align-center" });
            icons.push({ id: "align-right", name: "align-right" });
            icons.push({ id: "align-justify", name: "align-justify" });
            icons.push({ id: "list", name: "list" });
            icons.push({ id: "outdent", name: "Outdent" });
            icons.push({ id: "indent", name: "Indent" });
            icons.push({ id: "video-camera", name: "Video Camera" });
            icons.push({ id: "picture-o", name: "Picture Outlined" });
            icons.push({ id: "pencil", name: "pencil" });
            icons.push({ id: "map-marker", name: "map-marker" });
            icons.push({ id: "adjust", name: "adjust" });
            icons.push({ id: "tint", name: "tint" });
            icons.push({ id: "pencil-square-o", name: "Pencil Square Outlined" });
            icons.push({ id: "share-square-o", name: "Share Square Outlined" });
            icons.push({ id: "check-square-o", name: "Check Square Outlined" });
            icons.push({ id: "arrows", name: "Arrows" });
            icons.push({ id: "step-backward", name: "step-backward" });
            icons.push({ id: "fast-backward", name: "fast-backward" });
            icons.push({ id: "backward", name: "backward" });
            icons.push({ id: "play", name: "play" });
            icons.push({ id: "pause", name: "pause" });
            icons.push({ id: "stop", name: "stop" });
            icons.push({ id: "forward", name: "forward" });
            icons.push({ id: "fast-forward", name: "fast-forward" });
            icons.push({ id: "step-forward", name: "step-forward" });
            icons.push({ id: "eject", name: "eject" });
            icons.push({ id: "chevron-left", name: "chevron-left" });
            icons.push({ id: "chevron-right", name: "chevron-right" });
            icons.push({ id: "plus-circle", name: "Plus Circle" });
            icons.push({ id: "minus-circle", name: "Minus Circle" });
            icons.push({ id: "times-circle", name: "Times Circle" });
            icons.push({ id: "check-circle", name: "Check Circle" });
            icons.push({ id: "question-circle", name: "Question Circle" });
            icons.push({ id: "info-circle", name: "Info Circle" });
            icons.push({ id: "crosshairs", name: "Crosshairs" });
            icons.push({ id: "times-circle-o", name: "Times Circle Outlined" });
            icons.push({ id: "check-circle-o", name: "Check Circle Outlined" });
            icons.push({ id: "ban", name: "ban" });
            icons.push({ id: "arrow-left", name: "arrow-left" });
            icons.push({ id: "arrow-right", name: "arrow-right" });
            icons.push({ id: "arrow-up", name: "arrow-up" });
            icons.push({ id: "arrow-down", name: "arrow-down" });
            icons.push({ id: "share", name: "Share" });
            icons.push({ id: "expand", name: "Expand" });
            icons.push({ id: "compress", name: "Compress" });
            icons.push({ id: "plus", name: "plus" });
            icons.push({ id: "minus", name: "minus" });
            icons.push({ id: "asterisk", name: "asterisk" });
            icons.push({ id: "exclamation-circle", name: "Exclamation Circle" });
            icons.push({ id: "gift", name: "gift" });
            icons.push({ id: "leaf", name: "leaf" });
            icons.push({ id: "fire", name: "fire" });
            icons.push({ id: "eye", name: "Eye" });
            icons.push({ id: "eye-slash", name: "Eye Slash" });
            icons.push({ id: "exclamation-triangle", name: "Exclamation Triangle" });
            icons.push({ id: "plane", name: "plane" });
            icons.push({ id: "calendar", name: "calendar" });
            icons.push({ id: "random", name: "random" });
            icons.push({ id: "comment", name: "comment" });
            icons.push({ id: "magnet", name: "magnet" });
            icons.push({ id: "chevron-up", name: "chevron-up" });
            icons.push({ id: "chevron-down", name: "chevron-down" });
            icons.push({ id: "retweet", name: "retweet" });
            icons.push({ id: "shopping-cart", name: "shopping-cart" });
            icons.push({ id: "folder", name: "Folder" });
            icons.push({ id: "folder-open", name: "Folder Open" });
            icons.push({ id: "arrows-v", name: "Arrows Vertical" });
            icons.push({ id: "arrows-h", name: "Arrows Horizontal" });
            icons.push({ id: "bar-chart", name: "Bar Chart" });
            icons.push({ id: "twitter-square", name: "Twitter Square" });
            icons.push({ id: "facebook-square", name: "Facebook Square" });
            icons.push({ id: "camera-retro", name: "camera-retro" });
            icons.push({ id: "key", name: "key" });
            icons.push({ id: "cogs", name: "cogs" });
            icons.push({ id: "comments", name: "comments" });
            icons.push({ id: "thumbs-o-up", name: "Thumbs Up Outlined" });
            icons.push({ id: "thumbs-o-down", name: "Thumbs Down Outlined" });
            icons.push({ id: "star-half", name: "star-half" });
            icons.push({ id: "heart-o", name: "Heart Outlined" });
            icons.push({ id: "sign-out", name: "Sign Out" });
            icons.push({ id: "linkedin-square", name: "LinkedIn Square" });
            icons.push({ id: "thumb-tack", name: "Thumb Tack" });
            icons.push({ id: "external-link", name: "External Link" });
            icons.push({ id: "sign-in", name: "Sign In" });
            icons.push({ id: "trophy", name: "trophy" });
            icons.push({ id: "github-square", name: "GitHub Square" });
            icons.push({ id: "upload", name: "Upload" });
            icons.push({ id: "lemon-o", name: "Lemon Outlined" });
            icons.push({ id: "phone", name: "Phone" });
            icons.push({ id: "square-o", name: "Square Outlined" });
            icons.push({ id: "bookmark-o", name: "Bookmark Outlined" });
            icons.push({ id: "phone-square", name: "Phone Square" });
            icons.push({ id: "twitter", name: "Twitter" });
            icons.push({ id: "facebook", name: "Facebook" });
            icons.push({ id: "github", name: "GitHub" });
            icons.push({ id: "unlock", name: "unlock" });
            icons.push({ id: "credit-card", name: "credit-card" });
            icons.push({ id: "rss", name: "rss" });
            icons.push({ id: "hdd-o", name: "HDD" });
            icons.push({ id: "bullhorn", name: "bullhorn" });
            icons.push({ id: "bell", name: "bell" });
            icons.push({ id: "certificate", name: "certificate" });
            icons.push({ id: "hand-o-right", name: "Hand Outlined Right" });
            icons.push({ id: "hand-o-left", name: "Hand Outlined Left" });
            icons.push({ id: "hand-o-up", name: "Hand Outlined Up" });
            icons.push({ id: "hand-o-down", name: "Hand Outlined Down" });
            icons.push({ id: "arrow-circle-left", name: "Arrow Circle Left" });
            icons.push({ id: "arrow-circle-right", name: "Arrow Circle Right" });
            icons.push({ id: "arrow-circle-up", name: "Arrow Circle Up" });
            icons.push({ id: "arrow-circle-down", name: "Arrow Circle Down" });
            icons.push({ id: "globe", name: "Globe" });
            icons.push({ id: "wrench", name: "Wrench" });
            icons.push({ id: "tasks", name: "Tasks" });
            icons.push({ id: "filter", name: "Filter" });
            icons.push({ id: "briefcase", name: "Briefcase" });
            icons.push({ id: "arrows-alt", name: "Arrows Alt" });
            icons.push({ id: "users", name: "Users" });
            icons.push({ id: "link", name: "Link" });
            icons.push({ id: "cloud", name: "Cloud" });
            icons.push({ id: "flask", name: "Flask" });
            icons.push({ id: "scissors", name: "Scissors" });
            icons.push({ id: "files-o", name: "Files Outlined" });
            icons.push({ id: "paperclip", name: "Paperclip" });
            icons.push({ id: "floppy-o", name: "Floppy Outlined" });
            icons.push({ id: "square", name: "Square" });
            icons.push({ id: "bars", name: "Bars" });
            icons.push({ id: "list-ul", name: "list-ul" });
            icons.push({ id: "list-ol", name: "list-ol" });
            icons.push({ id: "strikethrough", name: "Strikethrough" });
            icons.push({ id: "underline", name: "Underline" });
            icons.push({ id: "table", name: "table" });
            icons.push({ id: "magic", name: "magic" });
            icons.push({ id: "truck", name: "truck" });
            icons.push({ id: "pinterest", name: "Pinterest" });
            icons.push({ id: "pinterest-square", name: "Pinterest Square" });
            icons.push({ id: "google-plus-square", name: "Google Plus Square" });
            icons.push({ id: "google-plus", name: "Google Plus" });
            icons.push({ id: "money", name: "Money" });
            icons.push({ id: "caret-down", name: "Caret Down" });
            icons.push({ id: "caret-up", name: "Caret Up" });
            icons.push({ id: "caret-left", name: "Caret Left" });
            icons.push({ id: "caret-right", name: "Caret Right" });
            icons.push({ id: "columns", name: "Columns" });
            icons.push({ id: "sort", name: "Sort" });
            icons.push({ id: "sort-desc", name: "Sort Descending" });
            icons.push({ id: "sort-asc", name: "Sort Ascending" });
            icons.push({ id: "envelope", name: "Envelope" });
            icons.push({ id: "linkedin", name: "LinkedIn" });
            icons.push({ id: "undo", name: "Undo" });
            icons.push({ id: "gavel", name: "Gavel" });
            icons.push({ id: "tachometer", name: "Tachometer" });
            icons.push({ id: "comment-o", name: "comment-o" });
            icons.push({ id: "comments-o", name: "comments-o" });
            icons.push({ id: "bolt", name: "Lightning Bolt" });
            icons.push({ id: "sitemap", name: "Sitemap" });
            icons.push({ id: "umbrella", name: "Umbrella" });
            icons.push({ id: "clipboard", name: "Clipboard" });
            icons.push({ id: "lightbulb-o", name: "Lightbulb Outlined" });
            icons.push({ id: "exchange", name: "Exchange" });
            icons.push({ id: "cloud-download", name: "Cloud Download" });
            icons.push({ id: "cloud-upload", name: "Cloud Upload" });
            icons.push({ id: "user-md", name: "user-md" });
            icons.push({ id: "stethoscope", name: "Stethoscope" });
            icons.push({ id: "suitcase", name: "Suitcase" });
            icons.push({ id: "bell-o", name: "Bell Outlined" });
            icons.push({ id: "coffee", name: "Coffee" });
            icons.push({ id: "cutlery", name: "Cutlery" });
            icons.push({ id: "file-text-o", name: "File Text Outlined" });
            icons.push({ id: "building-o", name: "Building Outlined" });
            icons.push({ id: "hospital-o", name: "hospital Outlined" });
            icons.push({ id: "ambulance", name: "ambulance" });
            icons.push({ id: "medkit", name: "medkit" });
            icons.push({ id: "fighter-jet", name: "fighter-jet" });
            icons.push({ id: "beer", name: "beer" });
            icons.push({ id: "h-square", name: "H Square" });
            icons.push({ id: "plus-square", name: "Plus Square" });
            icons.push({ id: "angle-double-left", name: "Angle Double Left" });
            icons.push({ id: "angle-double-right", name: "Angle Double Right" });
            icons.push({ id: "angle-double-up", name: "Angle Double Up" });
            icons.push({ id: "angle-double-down", name: "Angle Double Down" });
            icons.push({ id: "angle-left", name: "angle-left" });
            icons.push({ id: "angle-right", name: "angle-right" });
            icons.push({ id: "angle-up", name: "angle-up" });
            icons.push({ id: "angle-down", name: "angle-down" });
            icons.push({ id: "desktop", name: "Desktop" });
            icons.push({ id: "laptop", name: "Laptop" });
            icons.push({ id: "tablet", name: "tablet" });
            icons.push({ id: "mobile", name: "Mobile Phone" });
            icons.push({ id: "circle-o", name: "Circle Outlined" });
            icons.push({ id: "quote-left", name: "quote-left" });
            icons.push({ id: "quote-right", name: "quote-right" });
            icons.push({ id: "spinner", name: "Spinner" });
            icons.push({ id: "circle", name: "Circle" });
            icons.push({ id: "reply", name: "Reply" });
            icons.push({ id: "github-alt", name: "GitHub Alt" });
            icons.push({ id: "folder-o", name: "Folder Outlined" });
            icons.push({ id: "folder-open-o", name: "Folder Open Outlined" });
            icons.push({ id: "smile-o", name: "Smile Outlined" });
            icons.push({ id: "frown-o", name: "Frown Outlined" });
            icons.push({ id: "meh-o", name: "Meh Outlined" });
            icons.push({ id: "gamepad", name: "Gamepad" });
            icons.push({ id: "keyboard-o", name: "Keyboard Outlined" });
            icons.push({ id: "flag-o", name: "Flag Outlined" });
            icons.push({ id: "flag-checkered", name: "flag-checkered" });
            icons.push({ id: "terminal", name: "Terminal" });
            icons.push({ id: "code", name: "Code" });
            icons.push({ id: "reply-all", name: "reply-all" });
            icons.push({ id: "star-half-o", name: "Star Half Outlined" });
            icons.push({ id: "location-arrow", name: "location-arrow" });
            icons.push({ id: "crop", name: "crop" });
            icons.push({ id: "code-fork", name: "code-fork" });
            icons.push({ id: "chain-broken", name: "Chain Broken" });
            icons.push({ id: "question", name: "Question" });
            icons.push({ id: "info", name: "Info" });
            icons.push({ id: "exclamation", name: "exclamation" });
            icons.push({ id: "superscript", name: "superscript" });
            icons.push({ id: "subscript", name: "subscript" });
            icons.push({ id: "eraser", name: "eraser" });
            icons.push({ id: "puzzle-piece", name: "Puzzle Piece" });
            icons.push({ id: "microphone", name: "microphone" });
            icons.push({ id: "microphone-slash", name: "Microphone Slash" });
            icons.push({ id: "shield", name: "shield" });
            icons.push({ id: "calendar-o", name: "calendar-o" });
            icons.push({ id: "fire-extinguisher", name: "fire-extinguisher" });
            icons.push({ id: "rocket", name: "rocket" });
            icons.push({ id: "maxcdn", name: "MaxCDN" });
            icons.push({ id: "chevron-circle-left", name: "Chevron Circle Left" });
            icons.push({ id: "chevron-circle-right", name: "Chevron Circle Right" });
            icons.push({ id: "chevron-circle-up", name: "Chevron Circle Up" });
            icons.push({ id: "chevron-circle-down", name: "Chevron Circle Down" });
            icons.push({ id: "html5", name: "HTML 5 Logo" });
            icons.push({ id: "css3", name: "CSS 3 Logo" });
            icons.push({ id: "anchor", name: "Anchor" });
            icons.push({ id: "unlock-alt", name: "Unlock Alt" });
            icons.push({ id: "bullseye", name: "Bullseye" });
            icons.push({ id: "ellipsis-h", name: "Ellipsis Horizontal" });
            icons.push({ id: "ellipsis-v", name: "Ellipsis Vertical" });
            icons.push({ id: "rss-square", name: "RSS Square" });
            icons.push({ id: "play-circle", name: "Play Circle" });
            icons.push({ id: "ticket", name: "Ticket" });
            icons.push({ id: "minus-square", name: "Minus Square" });
            icons.push({ id: "minus-square-o", name: "Minus Square Outlined" });
            icons.push({ id: "level-up", name: "Level Up" });
            icons.push({ id: "level-down", name: "Level Down" });
            icons.push({ id: "check-square", name: "Check Square" });
            icons.push({ id: "pencil-square", name: "Pencil Square" });
            icons.push({ id: "external-link-square", name: "External Link Square" });
            icons.push({ id: "share-square", name: "Share Square" });
            icons.push({ id: "compass", name: "Compass" });
            icons.push({ id: "caret-square-o-down", name: "Caret Square Outlined Down" });
            icons.push({ id: "caret-square-o-up", name: "Caret Square Outlined Up" });
            icons.push({ id: "caret-square-o-right", name: "Caret Square Outlined Right" });
            icons.push({ id: "eur", name: "Euro (EUR)" });
            icons.push({ id: "gbp", name: "GBP" });
            icons.push({ id: "usd", name: "US Dollar" });
            icons.push({ id: "inr", name: "Indian Rupee (INR)" });
            icons.push({ id: "jpy", name: "Japanese Yen (JPY)" });
            icons.push({ id: "rub", name: "Russian Ruble (RUB)" });
            icons.push({ id: "krw", name: "Korean Won (KRW)" });
            icons.push({ id: "btc", name: "Bitcoin (BTC)" });
            icons.push({ id: "file", name: "File" });
            icons.push({ id: "file-text", name: "File Text" });
            icons.push({ id: "sort-alpha-asc", name: "Sort Alpha Ascending" });
            icons.push({ id: "sort-alpha-desc", name: "Sort Alpha Descending" });
            icons.push({ id: "sort-amount-asc", name: "Sort Amount Ascending" });
            icons.push({ id: "sort-amount-desc", name: "Sort Amount Descending" });
            icons.push({ id: "sort-numeric-asc", name: "Sort Numeric Ascending" });
            icons.push({ id: "sort-numeric-desc", name: "Sort Numeric Descending" });
            icons.push({ id: "thumbs-up", name: "thumbs-up" });
            icons.push({ id: "thumbs-down", name: "thumbs-down" });
            icons.push({ id: "youtube-square", name: "YouTube Square" });
            icons.push({ id: "youtube", name: "YouTube" });
            icons.push({ id: "xing", name: "Xing" });
            icons.push({ id: "xing-square", name: "Xing Square" });
            icons.push({ id: "youtube-play", name: "YouTube Play" });
            icons.push({ id: "dropbox", name: "Dropbox" });
            icons.push({ id: "stack-overflow", name: "Stack Overflow" });
            icons.push({ id: "instagram", name: "Instagram" });
            icons.push({ id: "flickr", name: "Flickr" });
            icons.push({ id: "adn", name: "App.net" });
            icons.push({ id: "bitbucket", name: "Bitbucket" });
            icons.push({ id: "bitbucket-square", name: "Bitbucket Square" });
            icons.push({ id: "tumblr", name: "Tumblr" });
            icons.push({ id: "tumblr-square", name: "Tumblr Square" });
            icons.push({ id: "long-arrow-down", name: "Long Arrow Down" });
            icons.push({ id: "long-arrow-up", name: "Long Arrow Up" });
            icons.push({ id: "long-arrow-left", name: "Long Arrow Left" });
            icons.push({ id: "long-arrow-right", name: "Long Arrow Right" });
            icons.push({ id: "apple", name: "Apple" });
            icons.push({ id: "windows", name: "Windows" });
            icons.push({ id: "android", name: "Android" });
            icons.push({ id: "linux", name: "Linux" });
            icons.push({ id: "dribbble", name: "Dribbble" });
            icons.push({ id: "skype", name: "Skype" });
            icons.push({ id: "foursquare", name: "Foursquare" });
            icons.push({ id: "trello", name: "Trello" });
            icons.push({ id: "female", name: "Female" });
            icons.push({ id: "male", name: "Male" });
            icons.push({ id: "gittip", name: "Gittip" });
            icons.push({ id: "sun-o", name: "Sun Outlined" });
            icons.push({ id: "moon-o", name: "Moon Outlined" });
            icons.push({ id: "archive", name: "Archive" });
            icons.push({ id: "bug", name: "Bug" });
            icons.push({ id: "vk", name: "VK" });
            icons.push({ id: "weibo", name: "Weibo" });
            icons.push({ id: "renren", name: "Renren" });
            icons.push({ id: "pagelines", name: "Pagelines" });
            icons.push({ id: "stack-exchange", name: "Stack Exchange" });
            icons.push({ id: "arrow-circle-o-right", name: "Arrow Circle Outlined Right" });
            icons.push({ id: "arrow-circle-o-left", name: "Arrow Circle Outlined Left" });
            icons.push({ id: "caret-square-o-left", name: "Caret Square Outlined Left" });
            icons.push({ id: "dot-circle-o", name: "Dot Circle O" });
            icons.push({ id: "wheelchair", name: "Wheelchair" });
            icons.push({ id: "vimeo-square", name: "Vimeo Square" });
            icons.push({ id: "try", name: "Turkish Lira (TRY)" });
            icons.push({ id: "plus-square-o", name: "Plus Square Outlined" });
            icons.push({ id: "space-shuttle", name: "Space Shuttle" });
            icons.push({ id: "slack", name: "Slack Logo" });
            icons.push({ id: "envelope-square", name: "Envelope Square" });
            icons.push({ id: "wordpress", name: "Wordpress Logo" });
            icons.push({ id: "openid", name: "OpenID" });
            icons.push({ id: "university", name: "University" });
            icons.push({ id: "graduation-cap", name: "Graduation Cap" });
            icons.push({ id: "yahoo", name: "Yahoo Logo" });
            icons.push({ id: "google", name: "Google Logo" });
            icons.push({ id: "reddit", name: "reddit Logo" });
            icons.push({ id: "reddit-square", name: "reddit Square" });
            icons.push({ id: "stumbleupon-circle", name: "StumbleUpon Circle" });
            icons.push({ id: "stumbleupon", name: "StumbleUpon Logo" });
            icons.push({ id: "delicious", name: "Delicious Logo" });
            icons.push({ id: "digg", name: "Digg Logo" });
            icons.push({ id: "pied-piper", name: "Pied Piper Logo" });
            icons.push({ id: "pied-piper-alt", name: "Pied Piper Alternate Logo" });
            icons.push({ id: "drupal", name: "Drupal Logo" });
            icons.push({ id: "joomla", name: "Joomla Logo" });
            icons.push({ id: "language", name: "Language" });
            icons.push({ id: "fax", name: "Fax" });
            icons.push({ id: "building", name: "Building" });
            icons.push({ id: "child", name: "Child" });
            icons.push({ id: "paw", name: "Paw" });
            icons.push({ id: "spoon", name: "spoon" });
            icons.push({ id: "cube", name: "Cube" });
            icons.push({ id: "cubes", name: "Cubes" });
            icons.push({ id: "behance", name: "Behance" });
            icons.push({ id: "behance-square", name: "Behance Square" });
            icons.push({ id: "steam", name: "Steam" });
            icons.push({ id: "steam-square", name: "Steam Square" });
            icons.push({ id: "recycle", name: "Recycle" });
            icons.push({ id: "car", name: "Car" });
            icons.push({ id: "taxi", name: "Taxi" });
            icons.push({ id: "tree", name: "Tree" });
            icons.push({ id: "spotify", name: "Spotify" });
            icons.push({ id: "deviantart", name: "deviantART" });
            icons.push({ id: "soundcloud", name: "SoundCloud" });
            icons.push({ id: "database", name: "Database" });
            icons.push({ id: "file-pdf-o", name: "PDF File Outlined" });
            icons.push({ id: "file-word-o", name: "Word File Outlined" });
            icons.push({ id: "file-excel-o", name: "Excel File Outlined" });
            icons.push({ id: "file-powerpoint-o", name: "Powerpoint File Outlined" });
            icons.push({ id: "file-image-o", name: "Image File Outlined" });
            icons.push({ id: "file-archive-o", name: "Archive File Outlined" });
            icons.push({ id: "file-audio-o", name: "Audio File Outlined" });
            icons.push({ id: "file-video-o", name: "Video File Outlined" });
            icons.push({ id: "file-code-o", name: "Code File Outlined" });
            icons.push({ id: "vine", name: "Vine" });
            icons.push({ id: "codepen", name: "Codepen" });
            icons.push({ id: "jsfiddle", name: "jsFiddle" });
            icons.push({ id: "life-ring", name: "Life Ring" });
            icons.push({ id: "circle-o-notch", name: "Circle Outlined Notched" });
            icons.push({ id: "rebel", name: "Rebel Alliance" });
            icons.push({ id: "empire", name: "Galactic Empire" });
            icons.push({ id: "git-square", name: "Git Square" });
            icons.push({ id: "git", name: "Git" });
            icons.push({ id: "hacker-news", name: "Hacker News" });
            icons.push({ id: "tencent-weibo", name: "Tencent Weibo" });
            icons.push({ id: "qq", name: "QQ" });
            icons.push({ id: "weixin", name: "Weixin (WeChat)" });
            icons.push({ id: "paper-plane", name: "Paper Plane" });
            icons.push({ id: "paper-plane-o", name: "Paper Plane Outlined" });
            icons.push({ id: "history", name: "History" });
            icons.push({ id: "circle-thin", name: "Circle Outlined Thin" });
            icons.push({ id: "header", name: "header" });
            icons.push({ id: "paragraph", name: "paragraph" });
            icons.push({ id: "sliders", name: "Sliders" });
            icons.push({ id: "share-alt", name: "Share Alt" });
            icons.push({ id: "share-alt-square", name: "Share Alt Square" });
            icons.push({ id: "bomb", name: "Bomb" });
            icons.push({ id: "futbol-o", name: "Futbol Outlined" });
            icons.push({ id: "tty", name: "TTY" });
            icons.push({ id: "binoculars", name: "Binoculars" });
            icons.push({ id: "plug", name: "Plug" });
            icons.push({ id: "slideshare", name: "Slideshare" });
            icons.push({ id: "twitch", name: "Twitch" });
            icons.push({ id: "yelp", name: "Yelp" });
            icons.push({ id: "newspaper-o", name: "Newspaper Outlined" });
            icons.push({ id: "wifi", name: "WiFi" });
            icons.push({ id: "calculator", name: "Calculator" });
            icons.push({ id: "paypal", name: "Paypal" });
            icons.push({ id: "google-wallet", name: "Goole Wallet" });
            icons.push({ id: "cc-visa", name: "Visa Credit Card" });
            icons.push({ id: "cc-mastercard", name: "MasterCard Credit Card" });
            icons.push({ id: "cc-discover", name: "Discover Credit Card" });
            icons.push({ id: "cc-amex", name: "American Express Credit Card" });
            icons.push({ id: "cc-paypal", name: "Paypal Credit Card" });
            icons.push({ id: "cc-stripe", name: "Stripe Credit Card" });
            icons.push({ id: "bell-slash", name: "Bell Slash" });
            icons.push({ id: "bell-slash-o", name: "Bell Slash Outlined" });
            icons.push({ id: "trash", name: "Trash" });
            icons.push({ id: "copyright", name: "Copyright" });
            icons.push({ id: "at", name: "At" });
            icons.push({ id: "eyedropper", name: "Eyedropper" });
            icons.push({ id: "paint-brush", name: "Paint Brush" });
            icons.push({ id: "birthday-cake", name: "Birthday Cake" });
            icons.push({ id: "area-chart", name: "Area Chart" });
            icons.push({ id: "pie-chart", name: "Pie Chart" });
            icons.push({ id: "line-chart", name: "Line Chart" });
            icons.push({ id: "lastfm", name: "last.fm" });
            icons.push({ id: "lastfm-square", name: "last.fm Square" });
            icons.push({ id: "toggle-off", name: "Toggle Off" });
            icons.push({ id: "toggle-on", name: "Toggle On" });
            icons.push({ id: "bicycle", name: "Bicycle" });
            icons.push({ id: "bus", name: "Bus" });
            icons.push({ id: "ioxhost", name: "ioxhost" });
            icons.push({ id: "angellist", name: "AngelList" });
            icons.push({ id: "cc", name: "Closed Captions" });
            icons.push({ id: "ils", name: "Shekel (ILS)" });
            icons.push({ id: "meanpath", name: "meanpath" });
            return icons;
        };
        return iconlist;
    }());
    return iconlist;
});

